import { createSlice } from "@reduxjs/toolkit";
import { guestUserLoginAPI } from "../../../services/guestUsers/guestUserAllAPIService";
import { STATUS_CODE } from "../../../common";
import { setItem } from "../../../common/localStorage";
import { GUEST_TOKEN_KEY } from "../../../common/authSession";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const guestUserLoginSlice = createSlice({
  name: "guestUserLoginSlice",
  initialState: data,
  reducers: {
    guestUserLoginSliceInfo(state) {
      state.isLoading = true;
    },
    guestUserLoginSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    guestUserLoginSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    guestUserLoginSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const guestUserLoginHandler = (data) => async (dispatch) => {
  try {
    dispatch(guestUserLoginSliceAction.guestUserLoginSliceInfo());
    const response = await guestUserLoginAPI(data);
    dispatch(guestUserLoginSliceAction.guestUserLoginSliceSuccess(response));
    const statusCode = response?.statusCode;
    const multipleMembers = response?.data?.multipleMembers;
    const memberCount = multipleMembers?.length ?? 0;

    if (
      statusCode === STATUS_CODE.OK &&
      (multipleMembers == null || memberCount === 0)
    ) {
      localStorage.setItem(GUEST_TOKEN_KEY, response?.data?.token);
      setItem("guestLoginResponse", response?.data);
    }
  } catch (e) {
    const message =
      typeof e === "string"
        ? e
        : e?.message || e?.response?.data?.message || "Something went wrong";
    dispatch(guestUserLoginSliceAction.guestUserLoginSliceFailure(message));
  }
};
export default guestUserLoginSlice.reducer;
export const guestUserLoginSliceAction = guestUserLoginSlice.actions;
